import { Panel } from "@poseidon/ui/components/Panel";
import { Grid, TextField } from "@mui/material";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Alert from "@mui/material/Alert";
import React from "react";
import { formatCurrency } from "@poseidon/utils/currency";
import VerifiedIcon from "@mui/icons-material/Verified";
import { getDate } from "@poseidon/firebase/timestamp";
export function QuoteDetailsPanel({ application }) {
  return (
    <Panel expandable title="Quote Details" anchorName="quote">
      {application.quoteValid && (
        <Chip
          icon={<VerifiedIcon />}
          label="Quote valid"
          color="success"
          sx={{ mb: 2 }}
        />
      )}
      {application.balloon > 0 && (
        <Chip label="Fixed rate" color="info" sx={{ mb: 2, ml: 1 }} />
      )}
      {!application.quoteValid && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Quote invalid: {application.quoteError}
        </Alert>
      )}
      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} sm={6}>
          <Stack spacing={2}>
            <TextField
              value={formatCurrency(application.costOfVessel)}
              label="Cost Of Vessel"
              margin="normal"
            />
            <TextField
              value={formatCurrency(application.deposit)}
              label="Deposit"
              margin="normal"
            />
            <TextField
              value={`${application.termMonths} months`}
              label="Term"
              margin="normal"
            />
            <TextField
              value={`${application.addonRate}% p.a.`}
              label="Addon Rate"
              margin="normal"
            />
            <TextField
              value={
                getDate(application.quoteGeneratedAt)?.toLocaleString() ??
                "Unknown"
              }
              label="Generated"
              margin="normal"
            />
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack spacing={2}>
            <TextField
              label="Amount Of Credit"
              margin="normal"
              value={formatCurrency(application.principal)}
            />
            <TextField
              value={formatCurrency(application.monthlyPayment, true)}
              label="Monthly Payment"
              margin="normal"
            />
            {application.balloon > 0 && (
              <TextField
                value={formatCurrency(application.balloon, true)}
                label="Balloon"
                margin="normal"
              />
            )}
            <TextField
              value={`${application.baseRate} p.a.`}
              label="Base Rate"
              margin="normal"
            />
            <TextField
              value={`${application.apr}%`}
              label="APR"
              margin="normal"
            />
            <TextField
              value={formatCurrency(application.totalPayable, true)}
              label="Total Payable"
              margin="normal"
            />
          </Stack>
        </Grid>
      </Grid>
    </Panel>
  );
}
